import { useEffect, useState } from "react";

const navLinks = [
  { label: "热门推荐", href: "#hot" },
  { label: "站点分类", href: "#categories" },
  { label: "最新发布", href: "#latest" },
  { label: "追更指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [faved, setFaved] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleFav = () => {
    setFaved(true);
    window.setTimeout(() => setFaved(false), 2000);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl ${
              scrolled ? "text-primary-600" : "text-background-50"
            }`}
          >
            韩漫导航
          </span>
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`whitespace-nowrap text-sm transition-colors ${
                scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-100/90 hover:text-white"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={handleFav}
            className="hidden whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex items-center gap-1.5 bg-primary-500"
          >
            <i className={faved ? "ri-star-fill" : "ri-star-line"}></i>
            {faved ? "已收藏本站" : "收藏本站"}
          </button>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`md:hidden flex h-10 w-10 items-center justify-center rounded-md border ${
              scrolled ? "border-background-200 text-foreground-900" : "border-background-200/40 text-background-50"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                {link.label}
              </a>
            ))}
            <button
              type="button"
              onClick={handleFav}
              className="mt-1 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              <i className="ri-star-line"></i>
              {faved ? "已收藏本站" : "收藏本站"}
            </button>
          </div>
        </div>
      )}
    </header>
  );
}